import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-contacts',
  templateUrl: './transfer-contacts.component.html',
  styleUrls: ['./transfer-contacts.component.scss'],
})
export class TransferContactsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
